import React from 'react';
import ReactDOM from 'react-dom';

const SimpleModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  // Cierra el modal al hacer clic en el overlay
  const handleOverlayClick = () => onClose();

  // Evita que el clic en el contenido cierre el modal
  const handleContentClick = (e) => e.stopPropagation();

  return ReactDOM.createPortal(
    <div
      className="simple-modal-overlay"
      onClick={handleOverlayClick}
      style={overlayStyle}
    >
      <div
        className="autocrm-simple-modal-content"
        onClick={handleContentClick}
        style={modalStyle}
      >
        <div className="simple-modal-header" style={headerStyle}>
          {title && (
            <h2 className="simple-modal-title" style={titleStyle}>
              {title}
            </h2>
          )}
          <button
            className="simple-modal-close"
            onClick={onClose}
            type="button"
            style={closeButtonStyle}
          >
            &times;
          </button>
        </div>
        <div className="simple-modal-body" style={bodyStyle}>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

// Estilos en línea (puedes trasladarlos a tu CSS si lo prefieres)
const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  backgroundColor: '#fff',
  borderRadius: '8px',
  maxWidth: '500px',
  width: '90%',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  padding: '20px',
};

const headerStyle = {
  display: 'flex',
  flexDirection: 'column', // Para centrar el título verticalmente
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '10px',
  borderBottom: '1px solid #eee',
};

const titleStyle = {
  margin: 0,
  fontSize: '1.5rem',
  textAlign: 'center',
};

const closeButtonStyle = {
  alignSelf: 'flex-end', // Alinea el botón de cierre a la derecha
  fontSize: '1.5rem',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
};

const bodyStyle = {
  paddingTop: '15px',
};

export default SimpleModal;
